import React from "react";
import './TourContainer.css'
function TourContainer(){
    return (
        <>
        <div className="tourcontainer">
            <h2>رحله في الاسلام</h2>
            <p>رحلة الإسلام من البداية
البداية: بدأ الإسلام عندما بعث الله النبي محمد صلى الله عليه وسلم رسولاً للبشرية في مكة المكرمة عام 610 ميلادي، حيث نزل عليه الوحي بواسطة جبريل عليه السلام في غار حراء.
الدعوة السرية: استمرت ثلاث سنوات، وكان النبي يدعو المقربين منه سرًا.
الدعوة العلنية: بدأ النبي بالدعوة جهارًا للقبائل في مكة، وتعرض وأصحابه للاضطهاد.
الهجرة إلى المدينة المنورة: هاجر النبي وأصحابه إلى المدينة عام 622 ميلادي، وبدأت مرحلة بناء الدولة الإسلامية.
الفتوحات الإسلامية: توسع الإسلام عبر الفتوحات والدعوة إلى الله، مما أدى إلى انتشار الدين في جميع أنحاء العالم</p>
        <h2>أركان الإسلام</h2>
        <p>أركان الإسلام هي خمسة أركان أساسية يقوم عليها الدين، وهي:

الشهادتان:
"أشهد أن لا إله إلا الله وأشهد أن محمدًا رسول الله".
تعني الإيمان بوحدانية الله وأن محمدًا هو رسول الله.
إقام الصلاة:
خمس صلوات في اليوم: الفجر، الظهر، العصر، المغرب، العشاء.
الصلاة هي صلة بين العبد وربه.
إيتاء الزكاة:
إخراج نسبة محددة من المال (2.5%) للفقراء والمحتاجين.
تحقق التكافل الاجتماعي.
صوم رمضان:
الامتناع عن الطعام والشراب والمعاصي من الفجر حتى غروب الشمس خلال شهر رمضان.
يُعلم الصبر والتقوى.
حج البيت:
لمن استطاع إليه سبيلًا.
يتم أداء الحج في مكة وهو ركن يُؤدى مرة واحدة في العمر</p>
<h2>أركان الإيمان</h2>
<p>أركان الإيمان هي ستة أركان تمثل المعتقدات الأساسية في الإسلام:

الإيمان بالله:
الإيمان بوجود الله ووحدانيته وصفاته.
الإيمان بالملائكة:
الإيمان بوجود الملائكة كخلق من نور، ينفذون أوامر الله.
الإيمان بالكتب السماوية:
الإيمان بكل الكتب التي أنزلها الله على أنبيائه (التوراة، الإنجيل، الزبور، القرآن).
الإيمان بالرسل:
الإيمان بجميع الأنبياء والرسل الذين أرسلهم الله لهداية البشر.
الإيمان باليوم الآخر:
الإيمان بأن الحياة الدنيا زائلة وأن هناك يوم حساب وجزاء.
الإيمان بالقدر خيره وشره:
الإيمان بأن كل ما يحدث في الكون هو بتقدير الله.</p>
        </div>
        </>
    )
}
export default TourContainer;